import { render, staticRenderFns } from "./HealthCheck35PsaThyroidLiverNR.vue?vue&type=template&id=01e7a2e0&scoped=true&"
import script from "./HealthCheck35PsaThyroidLiverNR.vue?vue&type=script&lang=js&"
export * from "./HealthCheck35PsaThyroidLiverNR.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck35PsaThyroidLiverNR.vue?vue&type=style&index=0&id=01e7a2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e7a2e0",
  null
  
)

export default component.exports